import React, {PureComponent} from "react";
import {connect} from "react-redux";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import Figures from "./Figures";
import Emoji from "./Emoji";
import Cliparts from "./Cliparts";
import Textures from "./Textures";
import Letterings from "./Letterings";

class DrawControl extends PureComponent {
  render() {
    return (
      <div className="panel-control">
        <div className="panel-control__title">Фигуры и графика</div>
        <div className="panel-control__content">
          <Figures />
          <Emoji />
          <Cliparts />
          <Textures />
          <Letterings />
        </div>
      </div>
    );
  }
}

export default connect()(withErrorBoundary(DrawControl));
